import { put, takeEvery, call, delay } from 'redux-saga/effects';
import { 
  SHOW_ERROR_MESSAGE,
  HIDE_ERROR_MESSAGE,
  CLEAR_ERROR_DISPLAY
} from './actions';

/**
 * Shows error message to user
 * @param {Object} action - Redux action with error message details
 */
function* showErrorMessageSaga(action) {
  try {
    const { message, type, context, duration = 5000 } = action.payload;

    // Dispatch action to show message
    yield put({
      type: 'DISPLAY_ERROR_MESSAGE',
      payload: {
        message,
        type,
        context,
        timestamp: new Date().toISOString()
      }
    });

    // Auto-hide message after duration (if specified)
    if (duration > 0) {
      yield call(delay, duration);
      yield put({ type: HIDE_ERROR_MESSAGE });
    }

  } catch (sagaError) {
    console.error('Error in showErrorMessageSaga:', sagaError);
  }
}

/**
 * Hides error message from user
 */
function* hideErrorMessageSaga() {
  try {
    yield put({
      type: 'HIDE_ERROR_DISPLAY'
    });
  } catch (sagaError) {
    console.error('Error in hideErrorMessageSaga:', sagaError);
  }
}

/**
 * Clears all error display state
 */
function* clearErrorDisplaySaga() {
  try {
    yield put({
      type: 'CLEAR_ERROR_DISPLAY_STATE'
    });
  } catch (sagaError) {
    console.error('Error in clearErrorDisplaySaga:', sagaError);
  }
}

/**
 * Handles error message dismissal by user
 */
function* handleErrorDismissalSaga(action) {
  try {
    const { reason = 'user_dismissed' } = action.payload;

    // Log dismissal for analytics
    console.log('Error message dismissed:', { reason });

    // Hide the message
    yield put({ type: HIDE_ERROR_MESSAGE });

  } catch (sagaError) {
    console.error('Error in handleErrorDismissalSaga:', sagaError);
  }
}

/**
 * Main error display saga watcher
 */
export function* errorDisplaySaga() {
  yield takeEvery(SHOW_ERROR_MESSAGE, showErrorMessageSaga);
  yield takeEvery(HIDE_ERROR_MESSAGE, hideErrorMessageSaga);
  yield takeEvery(CLEAR_ERROR_DISPLAY, clearErrorDisplaySaga);
  yield takeEvery('DISMISS_ERROR_MESSAGE', handleErrorDismissalSaga);
}

// Export individual sagas for testing
export { 
  showErrorMessageSaga, 
  hideErrorMessageSaga, 
  clearErrorDisplaySaga,
  handleErrorDismissalSaga
};
